export const OPEN_GRAPH_BASE_PATH = `${process.env.assetPathPrefix}/opengraph`;

export const globalOpenGraphImagePath = `${OPEN_GRAPH_BASE_PATH}/global_og_image.png`;
export const luobuOpenGraphImagePath = `${OPEN_GRAPH_BASE_PATH}/luobu_og_image.png`;
